<template>
  <avue-crud ref="crud" :option="option" :data="data" @row-save="rowSave" @row-update="rowUpdate">
    <template slot-scope="{type, size, row, index}" slot="menu">
      <el-button icon="el-icon-top" :size="size" :type="type" @click.stop="upRow(row, index)" />
      <el-button icon="el-icon-edit" :size="size" :type="type" @click.stop="handleEdit(row, index)" />
      <el-button icon="el-icon-delete" :size="size" :type="type" @click.stop="rowDel(row, index)" />
    </template>
  </avue-crud>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    orderData: {
      type: Array,
      default: () => []
    },
    column: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: this.orderData,
      option: {
        page: false,
        refreshBtn: false,
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 90,
        column: [
          {
            label: '字段',
            type: 'select',
            prop: 'column',
            dicData: []
          }, {
            label: '升序',
            prop: 'asc',
            type: 'select',
            dicData: [{
              label: '是',
              value: true
            }, {
              label: '否',
              value: false
            }],
            width: 50
          }
        ]
      }
    }
  },
  mounted() {
    if (this.column.length) {
      const dicData = []
      this.column.map(item => {
        const {
          label,
          prop
        } = item
        dicData.push({
          label,
          value: prop
        })
      })
      this.option.column[0].dicData = dicData
    }
  },
  methods: {
    rowSave(form, done, loading) {
      done(form)
      this.$emit('update:orderData', this.data)
    },
    rowUpdate(form, index, done, loading) {
      const {
        column,
        asc
      } = form
      this.orderData[index].column = column
      this.orderData[index].asc = asc
      this.$emit('update:orderData', this.data)
      done()
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index)
    },
    rowDel(form, index) {
      this.orderData.splice(index, 1)
    },
    upRow(row, index) {
      if (index === 0) {
        return
      }
      const items = _.cloneDeep(this.orderData)
      const item = items[index]
      const itemPre = items[index - 1]

      this.orderData[index - 1].asc = item.asc
      this.orderData[index - 1].column = item.column

      this.orderData[index].asc = itemPre.asc
      this.orderData[index].column = itemPre.column
    }
  }
}
</script>
